import { render } from "./NotFound.vue?vue&type=template&id=17189e28"
const script = {}
script.render = render

export default script